import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SimNaoModalComponent } from "./sim-nao-modal.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  declarations: [SimNaoModalComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class SimNaomModalModule {}
